import { useMenu } from '@if/mui'
import { Button, Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const CollectionMenu = () => {
  const { t } = useTranslation()
  const [buttonProps, menuProps, handleMenuClose] = useMenu()

  return (
    <>
      <Button {...buttonProps}>{t('menus.collection.collection')}</Button>
      <Menu {...menuProps}>
        <MenuItem>{t('menus.collection.dashboard')}</MenuItem>
        <MenuItem>{t('menus.collection.assignment')}</MenuItem>
        <MenuItem component={Link} to="/interac-wire" onClick={handleMenuClose}>
          {t('menus.collection.interacWire')}
        </MenuItem>
        <MenuItem component={Link} to="/interac-history" onClick={handleMenuClose}>
          {t('menus.collection.interacHistory')}
        </MenuItem>
      </Menu>
    </>
  )
}

export default CollectionMenu
